import { Dispatch } from "redux";
import {
	DocumentDetailsUpdatedAction,
	DocumentsActionTypes
} from "@/Actions/Documents";
import { Document } from "@/Contracts/Documents";
import { GlobalState } from "@/Reducers/interface";
import { getDocumentDetails } from "@/Services/Documents";

export const mergeSendTimeFields = (
	current: Document,
	latest: Document
): Document => ({
	...current,
	status: latest.status,
	document_expiry_details: latest.document_expiry_details,
	document_email_reminder_details: latest.document_email_reminder_details,
	is_public_link_enabled: latest.is_public_link_enabled
});

const activeDocumentWithId = (
	getState: () => GlobalState,
	documentId: string
): Document | null => {
	const current = getState().documents.currentActiveDocument;
	return current?.id === documentId ? current : null;
};

export const refreshSentDocument = async (
	documentId: string,
	dispatch: Dispatch,
	getState: () => GlobalState
): Promise<void> => {
	if (!activeDocumentWithId(getState, documentId)) {
		return;
	}
	try {
		const latest = await getDocumentDetails(documentId, false, true);
		const current = activeDocumentWithId(getState, documentId);
		if (current) {
			const documentDetailsUpdatedAction: DocumentDetailsUpdatedAction = {
				type: DocumentsActionTypes.DOCUMENT_DETAILS_UPDATED,
				currentActiveDocument: mergeSendTimeFields(current, latest)
			};
			dispatch(documentDetailsUpdatedAction);
		}
	} catch (error) {
		console.error("Failed to refresh document after sending", error);
	}
};
